
import React, { useEffect, useContext } from 'react'
import { SpinnerComponent } from 'react-element-spinner'
import {
	Card,
	CardBody,
	CardFooter,
	CardHeader,
	Col,
	Container,
	FormGroup,
	Input,
	Label,
	Row
} from 'reactstrap'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'

import { AuctionsContext } from '../../../../contexts/AuctionsProvider'
import Tires from '../../../../components/VehicleInspection/Tires'
import { InspectionsContext } from '../../../../contexts/InspectionsProvider'
import PageTitleContextMenu from '../../../../components/PageTitles/PageTitleContextMenu'
import AuctionsNavBar from '../../../../components/Navbars/AuctionsNavBar'

const AuctionCondition = ({ embedded = false, onRequestClose, onSelectDetailTab }) =>
{
	const { t } = useTranslation()
	const [isBusy, setIsBusy] = React.useState(false)
	const auctionsContext = useContext(AuctionsContext)
	const inspectionsContext = useContext(InspectionsContext)
	const navigate = useNavigate()
	
	useEffect(() =>
	{
		initializeComponent()
	}, [])
	
	const initializeComponent = () =>
	{
	
	}
	
	const handleGoBack = () =>
	{
		if (embedded)
		{
			if (typeof onRequestClose === 'function') onRequestClose()
			return
		}
		navigate('/secure/auctions-listing')
	}
	
	return (
		<div style={{
			zIndex: 500
		}}>
			<SpinnerComponent
				loading={ isBusy }
				position="global"
				color="#3578e5"
				secondaryColor="#f3f3f3"
				backgroundColor="#d3d3d3"
				spinnerType="circle-dots"
			/>
			{
				!embedded &&
				<PageTitleContextMenu
					heading={ t('Auctions.Condition.Title') }
					subheading={ auctionsContext.auction.auctionVehicle.vehicle.year + ' ' +
						auctionsContext.auction.auctionVehicle.vehicle.make + ' ' +
						auctionsContext.auction.auctionVehicle.vehicle.model + ' / ' +
						auctionsContext.auction.auctionVehicle.vehicle.trim + ' / ' +
						auctionsContext.auction.auctionVehicle.vehicle.serialNumber
					}
					icon="pe-7s-ticket icon-gradient bg-premium-dark"
					headerOptions={ { showBack: true, backCommand: () => { handleGoBack() }, showReload: false, reloadCommand: null } }
				/>
			}
			<Container className={ embedded ? "" : "mt--6" } fluid>
				<Row>
					<div className="col">
						<Card>
							<CardHeader style={{padding: '0.5rem 0.75rem'}}>
								<AuctionsNavBar
									parentComponent={'auction-condition'}
									onSelect={ embedded ? onSelectDetailTab : undefined }
								/>
							</CardHeader>
							<CardBody>
								<Row>
									<Col md="6">
										<FormGroup>
											<Label>
												{ t('Auctions.Condition.InspectionDate') }
											</Label>
											<Input
												disabled
												className="form-control-sm"
												type="text"
												value={ (inspectionsContext.vehicleInspection !== null) ? dayjs(inspectionsContext.vehicleInspection.inspectionDate).format('MMM DD, YYYY') : '' }
											/>
										</FormGroup>
									</Col>
									<Col md="6">
										<FormGroup>
											<Label>
												{ t('Auctions.Condition.Odometer') }
											</Label>
											<Input
												disabled
												className="form-control-sm"
												type="text"
												value={ (inspectionsContext.vehicleInspection !== null && inspectionsContext.vehicleInspection.inspectionMileage !== undefined) ? inspectionsContext.vehicleInspection.inspectionMileage.toLocaleString() : '' }
											/>
										</FormGroup>
									</Col>
								</Row>
								<Row>
									<Col md="12">
										<Tires vehicleId={ auctionsContext.auction.auctionVehicle.vehicleId } />
									</Col>
								</Row>
							</CardBody>
							<CardFooter></CardFooter>
						</Card>
					</div>
				</Row>
			</Container>
		</div>
	)
}

export default AuctionCondition
